import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const CookiesPolicy = () => {
  return (
    <>
      <Header />

      <div
        className="container"
        style={{
          marginTop: "150px",
          marginBottom: "60px",
          maxWidth: "1000px",
        }}
      >
        {/* Hero Section */}
        <div
          className="text-center text-white p-5 rounded"
          style={{
            background:
              "linear-gradient(135deg, #6B2A00 0%, #E3952A 100%)",
          }}
        >
          <h1 className="fw-bold mb-3">Cookies Policy</h1>
          <p className="mb-0">
            Learn how Ez Puja Path uses cookies and related technologies
            to improve your browsing experience.
          </p>
        </div>

        {/* Content Card */}
        <div
          className="bg-white shadow-sm rounded p-4 p-md-5 mt-4"
          style={{
            lineHeight: "1.9",
            color: "#444",
          }}
        >
          <p>
            <strong>Last Updated:</strong> June 2026
          </p>

          <p>
            Welcome to <strong>Ez Puja Path</strong>. This Cookies Policy
            explains how we use cookies and similar technologies when you
            visit our website, use our services, or interact with our
            platform.
          </p>

          <h3 className="mt-4">1. What Are Cookies?</h3>

          <p>
            Cookies are small text files stored on your device when you
            visit a website. They help websites remember user preferences,
            improve functionality, analyze website performance, and
            provide a better user experience.
          </p>

          <h3 className="mt-4">2. How We Use Cookies</h3>

          <h5 className="mt-3">Essential Cookies</h5>

          <p>
            These cookies are necessary for the website to function
            properly. They enable core features such as:
          </p>

          <ul>
            <li>User authentication and login</li>
            <li>Secure account access</li>
            <li>Session management</li>
            <li>Booking and checkout functionality</li>
          </ul>

          <p>
            Without these cookies, certain services may not be available.
          </p>

          <h5 className="mt-3">Performance and Analytics Cookies</h5>

          <p>
            These cookies help us understand how visitors interact with
            our website by collecting information such as:
          </p>

          <ul>
            <li>Pages visited</li>
            <li>Time spent on pages</li>
            <li>Navigation patterns</li>
            <li>Website performance metrics</li>
          </ul>

          <p>
            This information helps us improve our services and user
            experience.
          </p>

          <h5 className="mt-3">Functional Cookies</h5>

          <p>
            These cookies remember your preferences, including:
          </p>

          <ul>
            <li>Selected city or location</li>
            <li>Language preferences</li>
            <li>User settings</li>
            <li>Previously entered information</li>
          </ul>

          <p>
            These cookies help provide a more personalized experience.
          </p>

          <h5 className="mt-3">Marketing and Advertising Cookies</h5>

          <p>We may use cookies to:</p>

          <ul>
            <li>Measure the effectiveness of marketing campaigns</li>
            <li>Show relevant content and promotions</li>
            <li>Improve advertising performance</li>
          </ul>

          <p>
            These cookies do not store sensitive personal information.
          </p>

          <h3 className="mt-4">3. Third-Party Cookies</h3>

          <p>
            Some cookies may be placed by trusted third-party service
            providers, including:
          </p>

          <ul>
            <li>Analytics services</li>
            <li>Payment gateways</li>
            <li>Social media integrations</li>
            <li>Customer support tools</li>
          </ul>

          <p>
            These third parties may collect information in accordance
            with their own privacy policies.
          </p>

          <h3 className="mt-4">4. Managing Cookies</h3>

          <p>
            Most web browsers allow you to control or disable cookies
            through browser settings.
          </p>

          <p>You may:</p>

          <ul>
            <li>Delete existing cookies</li>
            <li>Block future cookies</li>
            <li>Receive notifications before cookies are stored</li>
          </ul>

          <p>
            Please note that disabling certain cookies may affect website
            functionality and user experience.
          </p>

          <h3 className="mt-4">5. Data Security</h3>

          <p>
            We implement reasonable security measures to protect
            information collected through cookies and related
            technologies. However, no online transmission or storage
            method is completely secure.
          </p>

          <h3 className="mt-4">6. Changes to This Cookies Policy</h3>

          <p>
            We may update this Cookies Policy from time to time to
            reflect changes in technology, legal requirements, or our
            business practices.
          </p>

          <p>
            Any updates will be posted on this page with a revised
            "Last Updated" date.
          </p>

          <h3 className="mt-4">7. Contact Us</h3>

          <p>
            If you have any questions regarding this Cookies Policy,
            please contact us:
          </p>

          <div
            className="p-4 rounded"
            style={{
              background: "#f8f9fa",
              borderLeft: "4px solid #E3952A",
            }}
          >
            <p className="mb-2">
              <strong>Ez Puja Path</strong>
            </p>

            <p className="mb-2">
              Email: info@ezpujapath.com
            </p>

            <p className="mb-2">
              Website: https://ezpujapaath.com
            </p>

            <p className="mb-0">
              Phone: +91 XXXXX XXXXX
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default CookiesPolicy;
